import dayjs from "dayjs";
import { isArray, isString } from "lodash";

import { TimeframeInputProps } from "./TimeframeInput";
import { PresetValue, PresetValueItem, TimeframePreset, TimeframeRange } from "./types";

export function getDateRangeFromValue(value?: PresetValue): TimeframeRange | undefined {
  switch (value) {
    case "all":
      return undefined;
    case "ytd":
      return [dayjs().startOf("year").toDate(), new Date()];
    default: {
      if (value) {
        const years = typeof value === "string" && value.endsWith("y") ? parseInt(value) : 1;
        return [dayjs().subtract(years, "year").toDate(), new Date()];
      }
      return undefined;
    }
  }
}

export function isTimeframeRange(
  value?: TimeframePreset | TimeframeRange
): value is TimeframeRange {
  return isArray(value);
}

export function getPresetValueItem(value?: TimeframePreset): PresetValueItem | undefined {
  if (isPresetValueItem(value)) {
    return value;
  }
  if (value) {
    return { label: value, value };
  }
  return undefined;
}

export function isPresetValueItem(value?: TimeframePreset): value is PresetValueItem {
  return !isString(value);
}

export function setRangeByType(type: TimeframeInputProps["type"]) {
  return (range?: TimeframeRange) => {
    if (type === "month" && range?.[0] && range?.[1]) {
      const start = dayjs(range[0]).startOf("month").format();
      const end = dayjs(range[1]).endOf("month").format();

      return [start, end] as TimeframeRange;
    }
    return range;
  };
}
